export default "__VITE_ASSET__9ce48a5f__"